@if (workflowItem$ | async) {
  <div class="dossier-split-screen">
    <div class="dossier-form-panel">
      <form [formGroup]="dossierItemFg">
        <snelstart-ui-text-form-control
          (change)="saveForm()"
          [disabledControl]="dossierItemFg.get('creator')?.value === 'SnelStart'"
          class="custom-input-400"
          formControlName="creator"
          id="name"
          label="Aangemaakt door"
        />

        <snelstart-ui-date-form-control
          [disabledControl]="true"
          class="custom-input-400"
          formControlName="dateCreation"
          id="dateCreation"
          label="Datum"
        />

        <snelstart-ui-textarea-form-control
          (change)="saveForm()"
          [disabledControl]="dossierItemFg.get('creator')?.value === 'SnelStart'"
          [rows]="10"
          class="custom-input-400"
          formControlName="opmerkingen"
          id="opmerkingen"
          label="Notitie"
        />

        @if (dossierItemFg && dossierItemFg.value.creator !== 'SnelStart') {
          @if (!dossierItemFg.value.attachment) {
            <div>
              <input
                #fileUpload
                (change)="onFileSelected($event)"
                accept="application/pdf"
                class="file-input"
                type="file"
              >

              <snelstart-ui-button
                (click)="fileUpload.click()"
                class="custom-input-400"
                icon="paperclip-vertical"
                type="secondary"
              >
                Voeg bijlage toe (max. 5Mb)
              </snelstart-ui-button>
            </div>

            @if (isZipTooLarge) {
              <snelstart-ui-alert type="warning">
                Het bijgevoegde bestandsformaat is groter dan het toegestane maximum van 5MB.
              </snelstart-ui-alert>
            }
          } @else {
            <snelstart-ui-textarea-form-control
              [disabledControl]="true"
              [rows]="2"
              class="custom-input-400"
              formControlName="nameAttachment"
              id="nameAttachment"
              label="Bijlage"
            />

            <snelstart-ui-button
              (click)="toonPdf()"
              class="custom-input-400"
              icon="file-export"
              type="secondary"
            >
              Download bijlage
            </snelstart-ui-button>
          }
        }
      </form>
    </div>

    <div class="dossier-preview-panel">
      @if (pdfPreviewUrl && dossierItemFg.value.attachment) {
        <iframe
          [src]="pdfPreviewUrl"
          class="pdf-preview"
          title="PDF voorbeeld"
        ></iframe>
      } @else {
        <div class="pdf-preview-empty">
          Geen PDF-bijlage geselecteerd
        </div>
      }
    </div>
  </div>
}
